import _ from 'underscore';
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Image, ImageFit } from '@fluentui/react';

import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { getImageListSummaryDetailsStyles } from './image-list-details-styles';

export const ImageListSummaryDetails = (props) => {
  const {
    images,
  } = props;

  const classes = useDefaultStyles(getImageListSummaryDetailsStyles);

  const thumbnails = _.map(images, placements => placements[0].Src);

  return (
    <div className={classNames(classes.container, 'image-list-summary-container')}>
      {_.map(thumbnails, src => (
        <Image src={src} className={classNames(classes.thumbnail, 'image-thumbnail')} imageFit={ImageFit.centerCover} />
      ))}
    </div>
  );
};

ImageListSummaryDetails.propTypes = {
  images: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};
